
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getCurrentCountries, GetCurrentCountriesApiParameter } from "@insite/client-framework/Services/WebsiteService";
import {  CountryCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { ApiHandlerNoApiParameter } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = ApiHandlerNoApiParameter<GetCurrentCountriesApiParameter, CountryCollectionModel>;

export const DispatchBeginLoadCurrentCountires: CustomHandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadCurrentCountires",
    });
};

export const RequestDataFromApi: CustomHandlerType = async props => {
    const response = await getCurrentCountries({});
    props.apiResult = response;
};

export const DispatchCompleteLoadCurrentCountires: CustomHandlerType = props => {
    props.dispatch({
        type: "Custom/CompleteLoadCurrentCountires",
        collection: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadCurrentCountires, RequestDataFromApi, DispatchCompleteLoadCurrentCountires];

const loadCurrentCountires = createHandlerChainRunner(chain, "LoadCurrentCountries");
export default loadCurrentCountires;
